"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuickSearch = exports.Option = void 0;
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const auto_complete_1 = __importDefault(require("antd/lib/auto-complete"));
exports.Option = auto_complete_1.default.Option;
class QuickSearch extends react_1.default.Component {
  constructor() {
    super(...arguments);
    this.input = react_1.default.createRef();
  }
  shouldComponentUpdate(nextProps) {
    const shouldFocusInput = nextProps.shouldFocusInput;
    if (shouldFocusInput) {
      this.input.current.focus();
      return true;
    }
    return false;
  }
  render() {
    const _this$props = this.props,
      dataSource = _this$props.dataSource,
      onSearch = _this$props.onSearch,
      onSelect = _this$props.onSelect,
      style = _this$props.style,
      placeholder = _this$props.placeholder,
      optionLabelProp = _this$props.optionLabelProp,
      shouldFocusInput = _this$props.shouldFocusInput,
      onBlur = _this$props.onBlur,
      onFocus = _this$props.onFocus,
      icon = _this$props.icon,
      iconClass = _this$props.iconClass,
      spin = _this$props.spin;
    return react_1.default.createElement(auto_complete_1.default, {
      style: style,
      onSearch: onSearch,
      onSelect: onSelect,
      placeholder: placeholder,
      optionLabelProp: optionLabelProp,
      autoFocus: shouldFocusInput,
      ref: this.input,
      onBlur: onBlur,
      onFocus: onFocus,
      dataSource: dataSource
    }, react_1.default.createElement(antd_1.Input, {
      suffix: icon && react_1.default.createElement(antd_1.Icon, {
        type: icon,
        className: iconClass,
        spin: spin
      })
    }));
  }
}
exports.QuickSearch = QuickSearch;
exports.default = QuickSearch;